import '@mux/mux-player';

// Mounts a <mux-player> inside the hook element and reports the first play back
// to the server, so the run can be attributed to the associated contact.
export default {
  MuxPlayer: {
    mounted() {
      this.mountPlayer();
    },

    updated() {
      if (this.playbackId === this.el.dataset.playbackId) return;

      this.teardownPlayer();
      this.mountPlayer();
    },

    destroyed() {
      this.teardownPlayer();
    },

    mountPlayer() {
      const { playbackId, envKey, autoplay, playReport, viewerUserId } = this.el.dataset;
      if (!playbackId) return;

      const report = parsePlayReport(playReport);

      const player = document.createElement('mux-player');
      player.setAttribute('playback-id', playbackId);
      player.setAttribute('stream-type', 'on-demand');
      player.style.width = '100%';
      player.style.height = '100%';
      player.style.display = 'block';

      if (envKey) player.setAttribute('env-key', envKey);
      if (autoplay === 'true') player.setAttribute('autoplay', 'muted');
      if (viewerUserId) player.setAttribute('metadata-viewer-user-id', viewerUserId);

      this.el.appendChild(player);
      this.player = player;
      this.playbackId = playbackId;

      if (report) this.bindPlayReport(player, report);
    },

    teardownPlayer() {
      if (this.onPlay && this.player) this.player.removeEventListener('play', this.onPlay);
      if (this.player) this.player.remove();

      this.player = null;
      this.playbackId = null;
      this.onPlay = null;
    },

    bindPlayReport(player, report) {
      let reported = false;

      this.onPlay = () => {
        if (reported) return;
        reported = true;

        fetch(report.url, {
          method: 'POST',
          headers: { 'content-type': 'application/json' },
          body: JSON.stringify({ token: report.token }),
          keepalive: true,
        }).catch(() => {
          reported = false;
        });
      };

      player.addEventListener('play', this.onPlay);
    },
  },
};

function parsePlayReport(rawReport) {
  if (!rawReport) return null;

  try {
    return JSON.parse(rawReport);
  } catch (_error) {
    return null;
  }
}
